/* eslint-disable no-dupe-keys */
import { ShipCircleIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import { VoyageInfo } from "../models/voyage.interfaces";
import { VoyageCard } from "./VoyageCard";
import { Tab, Tabs } from "./VoyageTabs";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

type VoyageInformationProps = {
  voyageInfoData: VoyageInfo[];
  className?: string;
};

const VoyageInformation: React.FC<VoyageInformationProps> = ({ voyageInfoData, className }) => {
  const theme = useAtomValue(themeAtom);

  const commencedVoyages = voyageInfoData.filter((item) => item.VOYAGE_STATUS_CODE === "Commenced");
  const scheduledData = voyageInfoData.filter((item) => item.VOYAGE_STATUS_CODE === "Scheduled");

  const currentAndNextVoyages = [commencedVoyages[0], scheduledData[0]].filter(Boolean);
  const pastVoyages = voyageInfoData?.filter(
    (item, index, self) =>
      item.VOYAGE_STATUS_CODE !== "Commenced" &&
      item.VOYAGE_STATUS_CODE !== "Scheduled" &&
      self.findIndex((i) => i.VESSEL_CODE === item.VESSEL_CODE && i.VOYAGE_NO === item.VOYAGE_NO) === index,
  );

  return (
    <div className={twMerge("flex flex-col gap-6 pt-6", className, theme.home.tailwind.textDefault)}>
      <div className="inline-flex h-8 items-center justify-start gap-2">
        <div>
          <p
            className={twMerge(
              "w-8 rounded-full text-center",
              theme.myVesselsTable.tailwind.emptyStateIconBg,
              theme.home.tailwind.spinner,
            )}
          >
            <ShipCircleIcon className="mr-2 h-8 w-8" />
          </p>
        </div>
        <div className="font-bold">Voyages</div>
      </div>

      <div>
        <Tabs>
          <Tab label="Current and next">
            {currentAndNextVoyages.length > 0 ? (
              currentAndNextVoyages.map((item, index) => (
                <VoyageCard
                  key={index}
                  // @ts-expect-error Fix VoyageInfo type
                  item={item}
                />
              ))
            ) : (
              <NoData />
            )}
          </Tab>

          <Tab label="Past">
            {pastVoyages.length > 0 ? (
              pastVoyages.map((item, index) => (
                <VoyageCard
                  key={index}
                  // @ts-expect-error Fix VoyageInfo type
                  item={item}
                />
              ))
            ) : (
              <NoData />
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

const NoData = () => <span className="flex justify-center py-5">No data</span>;

export default VoyageInformation;
